var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice_dialog",class:{  },attrs:{"id":"be-notice-background"}},[_c('div',{staticClass:"dialog_content be-notice-wrap",class:this.data._id,style:(_vm.contentStyle),attrs:{"id":this.data._id},domProps:{"innerHTML":_vm._s(this.data.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }